<template>
  <b-modal
    id="delete-account-modal"
    ref="modal"
    :title="$t('Account.Delete')"
    @ok="handleOk"
    :ok-title="$t('Validate')"
    :cancel-title="$t('Cancel')"
    cancel-variant="danger">

    <div class="mb-4">
      {{ $t('Account.Delete.Confirm')}}
    </div>

  </b-modal>
</template>

<script>
import api from '../../services/api'
import {mapActions} from 'vuex'

export default {

  name: 'delete-account-modal',

  methods: {

    ...mapActions(['LogIn']),

    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit () {

      api({
        method: 'POST',
        url: `/account/deleteAccount`
      })
        .then(() => {
          this.$store.dispatch('LogOut')
          this.$router.push({
            name: 'Login'
          }, () => {
            this.$nextTick(() => {
              this.successToast()
            })
          })
        })
        .catch(() => {
          this.errorToast()
        })
    },

    successToast () {
      this.$bvToast.toast(this.$i18n.t('Account.Delete.Success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/account/DeleteAccountModal.vue